import React, { useState, useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_PESO_DESTARE } from '../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../config/settings'
import PesadoDestare0 from './PesadoDestareBalancero'
import * as actions from '../../actions'
import { connect } from 'react-redux'

function PesadoDestare (props) {
  const { destareStep, pesoDeCabezal, modo } = props
  const [init, setInit] = useState(false)

  const pesadoAuto = (modo === 'auto')

  useEffect(() => {
    async function setUp () {
      const parametros = await props.queryParametrosDestare()
      console.log(parametros)
    }

    if (!init) {
      setUp()
      setInit(true)
    }
  }, [props, init])

  const handleSubmit = (repeso) => {
    props.submitPesadoDestare(repeso)
  }

  const reimprimirUltimoTicket = () => {
    props.reimprimirUltimoTicketDescarga()
  }

  const updateEnclavamiento = (newValue) => {
    props.updateEnclavamiento(newValue)
  }

  const impresoraChange = () => {
    props.resetPrinterDestare()
  }

  return (
    <div className='pesado-container'>
      <ToastContainer autoClose={INTERVALO_CORTO} />

      {(destareStep === 0) && <PesadoDestare0
        pesoDeCabezal={pesoDeCabezal}
        handleSubmit={handleSubmit}
        pesadoAuto={pesadoAuto}
        reimprimirTicket={reimprimirUltimoTicket}
        updateEnclavamiento={updateEnclavamiento}
        impresoraChange={impresoraChange}
      />
      }
    </div>
  )
}

const selector = formValueSelector(FORM_PESO_DESTARE)

const mapStateToProps = (state) => {
  return {
    destareStep: state.pesado.destareStep,
    modo: state.pesado.pesajeDestare,
    numero: selector(state, 'numero'),
    repeso: state.pesado.repesoDestare
  }
}

const withReduxForm = reduxForm({
  form: FORM_PESO_DESTARE,
  destroyOnUnmount: false
})

const withRedux = connect(mapStateToProps, actions)
export default withRedux(withReduxForm(PesadoDestare))
